// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.picture {
    max-height: 100vh;
    max-width: 100vw;
    display: block;
    margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Picture.css"],"names":[],"mappings":";;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB","sourcesContent":["\r\n\r\n.picture {\r\n    max-height: 100vh;\r\n    max-width: 100vw;\r\n    display: block;\r\n    margin: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
